import { corporateCMSApi } from "~/Services";
import { decodeHTML } from "~/Utils/CommonUtils";
import { ModuleFields } from "~/Utils/drilldownData";

// Define the option type for select fields
export interface OptionType {
  label: string;
  value: string;
}

// Create a type for fields that may have async options
export type AsyncSelectField = ModuleFields & {
  loadOptions?: () => Promise<OptionType[]>;
};

// Function to fetch data and transform to options
const fetchDataAndTransform = async (url: string): Promise<OptionType[]> => {
  try {
    const res = await corporateCMSApi.get(`${url}`);
    if (res?.data) {
      return res.data
        .filter((item: any) => {
          const hasNameEn = typeof item?.name_en === "string" && item?.name_en?.trim() !== "";
          return item.published === true && hasNameEn;
        })
        .map((item: any) => ({
          label: decodeHTML(item.name_en),
          value: item.id,
        }));
    }
    return [];
  } catch (err) {
    console.error("Error fetching data:", err);
    return [];
  }
};
const fetchParentDataAndTransform = async (url: string): Promise<OptionType[]> => {
  try {
    const res = await corporateCMSApi.get(`${url}`);
    if (res?.data) {
      return res.data.map((item: any) => ({
        label: decodeHTML(item.name || item.name_en),
        value: item.name || item.name_en,
      }));
    }
    return [];
  } catch (err) {
    console.error("Error fetching data:", err);
    return [];
  }
};

export const fetchParentData = () => fetchParentDataAndTransform("/api/get-main-menu/allfields");

export const fetchChildData = () => fetchDataAndTransform("/api/get-child-menu/allfields");
